import React from 'react'
import { Redirect } from 'react-router-dom'
import { t } from 'i18next'
import Navigation from 'Components/Navigation'
import useValidatePermission from 'Hooks/useValidatePermission'
import { VAPermissions, ROUTES } from 'Utils/constants'
import './yappyConfig.css'

export default function YappyConfig() {
  const hasSettingsPermission = useValidatePermission(VAPermissions.settingsVA)

  if (!hasSettingsPermission) {
    return <Redirect to={ROUTES.home} />
  }

  return (
    <>
      <Navigation />
      <div
        className="yappy-config-container"
        data-testid="container-yappy-config">
        <div className="yappy-config-header">
          <h1 className="yappy-config-title">{t('SETTINGS_T.YAPPY')}</h1>
        </div>
      </div>
    </>
  )
}
